import * as analytics from 'analytics/Analytics';
import * as EventConstants from 'constants/EventConstants';
import AppDispatcher from 'lib/Dispatcher';
import FullScreenStore from 'nav/full-screen/FullScreenStore';
import Store from 'lib/Store';

import {ALL_SCREENS, FLOWS} from './NewUserFlowConstants';

class NewUserFlowStore extends Store {
  resetState() {
    FullScreenStore.resetState();
    this.currentFlow = null;
    this.currentFlowIndex = null;
    this.isLoading = false;
    this.projectId = null;
  }

  isScreenSupported(screen) {
    return ALL_SCREENS.includes(screen);
  }

  getProjectId() {
    return this.projectId;
  }

  getIsLoading() {
    return this.isLoading;
  }

  updateScreenForFlow() {
    const flow = FLOWS[this.currentFlow];
    if (!flow) {
      return;
    }
    if (this.currentFlowIndex >= flow.length) {
      FullScreenStore.hideScreen();
      this.resetState();
      return;
    }
    FullScreenStore.showScreen(flow[this.currentFlowIndex], this.currentFlow);
  }

  payloadHandler(action) {
    switch (action.actionType) {
      case EventConstants.SIDEBAR_OPEN_FOR_FILE_TYPE:
        this.resetState();
        this.emitChange();
        break;

      case EventConstants.HIDE_FULL_SCREEN:
        this.resetState();
        AppDispatcher.waitFor([FullScreenStore.dispatchIndex]);
        this.emitChange();
        break;

      case EventConstants.SHOW_FULL_SCREEN:
        if (this.isScreenSupported(action.screen)) {
          AppDispatcher.waitFor([FullScreenStore.dispatchIndex]);
          this.emitChange();
        }
        break;

      case EventConstants.BEGIN_NEW_USER_FLOW:
        this.currentFlow = action.flow;
        this.currentFlowIndex = 0;
        this.updateScreenForFlow();
        this.emitChange();

        analytics.track('new_user_flow', 'began_flow', {
          flow: action.flow,
        });
        break;

      case EventConstants.SHOW_NEXT_NEW_USER_FLOW_SCREEN:
        this.currentFlowIndex += 1;
        this.updateScreenForFlow();
        this.emitChange();
        break;

      case EventConstants.UPDATE_NEW_USER_FLOW_PROJECT:
        this.projectId = action.projectId;
        this.emitChange();
        break;

      case EventConstants.NEW_USER_FLOW_IS_LOADING:
        this.isLoading = true;
        this.emitChange();
        break;

      case EventConstants.NEW_USER_FLOW_DONE_LOADING:
        this.isLoading = false;
        this.emitChange();
        break;

      default:
        break;
    }
    return true;
  }
}

export default new NewUserFlowStore(AppDispatcher);
